/* Progressive enhancement only: native GET filters and POST cart remain usable. */
(() => {
  // v015 keeps the full header space in the document while the fixed bar shrinks.
  // Measure the group so an optional announcement remains outside the logo area.
  const root = document.documentElement;
  let headerObserver;
  let headerFrame;
  const updateHeader = () => {
    headerFrame = null;
    const compact = root.classList.contains('header-compact');
    root.classList.toggle('header-compact', window.scrollY > (compact ? 32 : 96));
  };
  const mountHeader = () => {
    headerObserver?.disconnect();
    const masthead = document.querySelector('.masthead');
    const group = masthead?.closest('.shopify-section-group-header-group');
    if (!group || !window.ResizeObserver) return;
    const measure = () => {
      const height = group.getBoundingClientRect().height;
      const barHeight = masthead.getBoundingClientRect().height;
      const fullBarHeight = parseFloat(getComputedStyle(root).getPropertyValue('--header'));
      root.style.setProperty('--header-space', `${height - barHeight + fullBarHeight}px`);
      root.style.setProperty('--visible-header', `${height}px`);
    };
    measure();
    root.classList.add('has-fixed-header');
    updateHeader();
    headerObserver = new ResizeObserver(measure);
    headerObserver.observe(group);
  };
  mountHeader();
  window.addEventListener('scroll', () => {
    if (headerFrame == null) headerFrame = requestAnimationFrame(updateHeader);
  }, { passive: true });
  document.addEventListener('shopify:section:load', mountHeader);
  const closeDisclosure = (details, focus = true) => {
    if (!details) return;
    details.open = false;
    if (focus) details.querySelector('summary')?.focus();
  };
  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-disclosure-close]');
    if (close) closeDisclosure(close.closest('details'));
    document.querySelectorAll('[data-disclosure][open]').forEach((details) => {
      if (!details.contains(event.target)) closeDisclosure(details, false);
    });
  });
  document.addEventListener('focusin', (event) => {
    document.querySelectorAll('[data-disclosure][open]').forEach((details) => {
      if (!details.contains(event.target)) closeDisclosure(details, false);
    });
  });
  document.addEventListener('toggle', (event) => {
    if (!event.target.matches('[data-disclosure]') || !event.target.open) return;
    document.querySelectorAll('[data-disclosure][open]').forEach((details) => {
      if (details !== event.target) closeDisclosure(details, false);
    });
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const details = event.target.closest('[data-disclosure][open]');
    if (details) {
      event.preventDefault();
      closeDisclosure(details);
    }
  });
  // Retain the exact server-filtered, sorted page, never filter only the DOM products.
  // Links are validated again when read: storage is untrusted and may be unavailable.
  const key = 'bananana.catalog.v1';
  const safeURL = (value, type) => {
    if (typeof value !== 'string') return null;
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin) return null;
      const match = type === 'product' ? /\/products\/[^/]+\/?$/ : /\/collections\/[^/]+\/?$/;
      return match.test(url.pathname) ? url : null;
    } catch { return null; }
  };
  const handleOf = (url) => url.pathname.split('/products/')[1]?.replace(/\/$/, '');
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-catalog] [data-product-link]');
    if (!link) return;
    const catalog = link.closest('[data-catalog]');
    const links = [...catalog.querySelectorAll('[data-product-link]')].map((item) => item.href).filter((href) => safeURL(href, 'product'));
    // Home links use a localized collection URL; return to home itself is also allowed.
    try { sessionStorage.setItem(key, JSON.stringify({ links, back: location.href, scrollY: window.scrollY, language: document.documentElement.lang, time: Date.now() })); } catch { /* Private mode still has native links. */ }
  });
  const product = document.querySelector('[data-product-page]');
  if (!product) {
    try {
      const destination = sessionStorage.getItem(`${key}.restore`);
      sessionStorage.removeItem(`${key}.restore`);
      const context = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (destination === location.href && context?.back === destination && context.language === document.documentElement.lang && Number.isFinite(context.time) && context.time <= Date.now() && Date.now() - context.time < 3600000 && Number.isFinite(context.scrollY) && context.scrollY >= 0) {
        document.documentElement.dataset.catalogRestored = 'true';
        requestAnimationFrame(() => window.scrollTo({ top: context.scrollY, behavior: 'instant' }));
      }
    } catch { /* Browser back navigation still restores its native history position. */ }
    return;
  }
  try {
    const context = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (!context || !Array.isArray(context.links) || context.links.length > 50 || context.language !== document.documentElement.lang || !Number.isFinite(context.time) || context.time > Date.now() || Date.now() - context.time > 3600000) return;
    const links = context.links.map((url) => safeURL(url, 'product')).filter(Boolean);
    const index = links.findIndex((url) => handleOf(url) === product.dataset.productHandle);
    if (index < 0) return;
    const back = new URL(context.back, location.origin);
    if (back.origin !== location.origin || (!safeURL(back.href, 'collection') && !/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/?)?$/.test(back.pathname))) return;
    product.querySelector('[data-catalog-back]').href = back.href;
    product.querySelector('[data-catalog-back]').addEventListener('click', () => {
      try { sessionStorage.setItem(`${key}.restore`, back.href); } catch { /* Optional restoration. */ }
    });
    const bind = (selector, url) => {
      const anchor = product.querySelector(selector);
      if (url && anchor) { anchor.href = url.href; anchor.hidden = false; }
    };
    bind('[data-piece-previous]', links[index - 1]);
    bind('[data-piece-next]', links[index + 1]);
    product.querySelector('[data-piece-siblings]').hidden = links.length < 2;
  } catch { /* Direct visits keep an explicit return to the native catalogue. */ }
})();

